import { makeRequest } from "./api";

export const FetchMaxNights = async () => {
  return makeRequest("/api/admin/maxNights/fetch");
};

export const UpdateMaxNights = async (
  itemName,
  otherItemName,
  startValue,
  endValue
) => {
  return makeRequest("/api/admin/maxNights/update", {
    method: "PUT",
    data: {
      itemName,
      otherItemName,
      startValue,
      endValue,
    },
  });
};
